import { startState } from 'codemirror';
import * as types from './mutation-types';
import { SEARCH_PARAMS, POPUP_DATA, PAGING_INFO } from './state';

export default {
	[types.STATE_INIT]: state => {
		state.isMmcAdmin = false;
		state.isMmcManager = false;
		state.searchParams = SEARCH_PARAMS();
		state.pagingInfo = PAGING_INFO();

		state.calInstCdList = []; //교정업체 selectBox
		state.calStCdList = []; //교정상태 selectBox
		state.runStCdList = []; //가동상태 selectBox
		state.calWayCdList = []; //교정방식 selectBox
		state.calCyclCdList = []; //교정주기 selectBox
		state.calRsltCdList = []; //교정결과 selectBox
		state.runStCdList = []; //가동상태 selectBox
		state.ynCdList = []; //보고서유무 selectBox

		state.useYnList = [];
		state.resultList = [];

		state.emlResultList = [];
		state.emlPagingInfo = PAGING_INFO();

		state.infmResultList = [];

		state.whsnResultList = [];
	},
	[types.POPUP_STATE_INIT]: state => {
		state.popupData = POPUP_DATA();
	},
	[types.DEFAULT_ASSIGN]: (state, { key, value }) => {
		state[key] = value;
	},
	[types.SEARCH_PARAM]: (state, { key, value }) => {
		state.searchParams[key] = value;
	},
	[types.PAGING_INFO]: (state, { key, value, gubun }) => {
		if (!gubun) {
			state.pagingInfo[key] = value;
		} else {
			state[gubun][key] = value;
		}
	},
	[types.POPUP_SET_FORM]: (state, { key, value }) => {
		state.popupData[key] = value;
	},
	[types.SELECTED_PARAM]: (state, { key, value }) => {
		state.popupData[key] = value;
	}
};
